/**
 * Centralized Storage Keys
 * Format: primum[:{env}]:{feature}:{thing}
 * - kebab-case
 * - standard suffixes: -shown, -enabled, -at, -until, -count
 * - ISO strings for dates
 *
 * Organized by feature areas:
 * - analytics: Segment analytics configuration
 * - features: Feature flags and toggles
 * - monitoring: Error tracking and monitoring
 * - community: Community-related settings
 * - notification: Push notification settings
 * - onboarding: User onboarding flow state
 * - account linking: Account linking flow state
 */

export const STORAGE_KEYS = {
  ACCOUNT_LINKING_CONTEXT: 'primum:account-linking:context',
  ANALYTICS_SEGMENT_ENABLED: 'primum:analytics:segment-enabled',
  ANNOUNCEMENT_INBOX_BANNER_DISMISSED: 'primum:announcement:inbox-banner-dismissed',
  CASE_LAYOUT_DEBUG: 'primum:debug:case-layout',
  CHAT_DRAFT_PREFIX: 'primum:chat:draft',
  COMMUNITY_DISCLAIMER_SHOWN: 'primum:community:disclaimer-shown',
  CONTENT_LIBRARY_CLINICIAN_ATTESTED: 'primum:content-library:clinician-attested',
  DIRECTORY_FEATURED_EXPERTS_VIEWED: 'primum:directory:featured-experts-viewed',
  FEATURES_ANNOUNCEMENT_BANNER_ENABLED: 'primum:features:announcement-banner-enabled',
  INBOX_QUESTION_GROUP_CARDS_OPT_IN: 'primum:inbox-question-group-cards-opt-in',
  INQUIRY_DEMO_ONBOARDING_DEFERRED_UNTIL: 'primum:inquiry-demo:onboarding-deferred-until',
  MONITORING_SENTRY_ENABLED: 'primum:monitoring:sentry-enabled',
  NEW_QUESTION_DRAFT: 'primum:new-question:draft',
  RESEARCH_HISTORY_COLLAPSED: 'primum:research:history-collapsed',
  ONBOARDING_INQUIRY_DEMO_SHOWN: 'primum:onboarding:inquiry-demo-shown',
  REPLY_DRAFT_HAND_OFFS: 'primum:reply-draft:hand-offs',
  SURVEY_ACKNOWLEDGED: 'primum:survey:acknowledged',
  SURVEY_DRAFT_PREFIX: 'primum:survey:draft',
  SURVEY_VISITED: 'primum:survey:visited',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
